import { FC } from "react";

import { MessageBar, MessageBarType } from "@bps/fluent-ui";
import { claimStatusErrors } from "@libs/gateways/acc/AccGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { ConditionHelper } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/context/ConditionHelper.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { ErrorBlock } from "@ui-components/ErrorBlock.tsx";
import { Navigate } from "@ui-components/navigation/Navigate.tsx";

type OverviewCardGetStatusErrorProps = {
  status: string | undefined;
  errorMessage: string | undefined;
  errorDetails: string | undefined;
  conditionHelper: ConditionHelper;
};

export const OverviewCardGetStatusError: FC<
  OverviewCardGetStatusErrorProps
> = ({ conditionHelper, errorDetails, errorMessage, status }) => {
  const { acc } = useStores();

  const messageBarIconStyles = { iconContainer: { alignItems: "center" } };

  if (status && claimStatusErrors.includes(status) && errorMessage) {
    if (
      errorMessage.includes("duplicate") &&
      errorDetails &&
      conditionHelper.episodeOfCare?.claim
    ) {
      const claim = conditionHelper.episodeOfCare.claim;

      return (
        <ErrorBlock
          errorText={errorMessage}
          linkText="Update claim & requery ACC"
          onClick={async () => {
            await acc.patchClaim({
              ...claim.dto,
              claimNumber: errorDetails
            });
            await acc.queueClaimStatus(claim.id);
          }}
        />
      );
    } else {
      return (
        <MessageBar
          messageBarIconProps={{ iconName: "Blocked2" }}
          messageBarType={MessageBarType.error}
          styles={messageBarIconStyles}
        >
          {errorMessage}{" "}
          <Navigate to={routes.settings.accErrorLog.basePath.path({})}>
            ACC error log
          </Navigate>
        </MessageBar>
      );
    }
  }
  return null;
};
